<app-autocomplete-select
  placeholder="{{'search.companies_individuals' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
